<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorConsultModal from "@/components/DoctorConsultModal";
import CreateReferralForm from "@/components/referral/CreateReferralForm.vue";

/**
 * Doctors Dashboard component
 */
export default {
  components: {
    Layout,
    PageHeader,
    DoctorConsultModal,
    CreateReferralForm
  },
  data() {
    return {
      title: "Doctors Dashboard",
      items: [
        {
          text: "Nazox",
          href: "/"
        },
        {
          text: "Doctors Dashboard",
          active: true
        }
      ],
      doctorStats: [
        {
          title: "Total Patients",
          value: 125,
          icon: "ri-user-line",
          color: "primary"
        },
        {
          title: "Appointments Today",
          value: 18,
          icon: "ri-calendar-check-line",
          color: "success"
        },
        {
          title: "Pending Reports",
          value: 7,
          icon: "ri-file-list-3-line",
          color: "warning"
        },
        {
          title: "Completed Consultations",
          value: 42,
          icon: "ri-check-double-line",
          color: "info"
        }
      ],
      upcomingAppointments: [
        {
          id: 1,
          patientName: "John Doe",
          time: "09:30 AM",
          reason: "Follow-up",
          status: "Confirmed"
        },
        {
          id: 2,
          patientName: "Jane Smith",
          time: "10:15 AM",
          reason: "Initial Consultation",
          status: "Confirmed"
        },
        {
          id: 3,
          patientName: "Robert Johnson",
          time: "11:00 AM",
          reason: "Test Results",
          status: "Pending"
        },
        {
          id: 4,
          patientName: "Emily Wilson",
          time: "01:30 PM",
          reason: "Medication Review",
          status: "Confirmed"
        },
        {
          id: 5,
          patientName: "Michael Brown",
          time: "02:45 PM",
          reason: "Follow-up",
          status: "Confirmed"
        }
      ],
      recentPatients: [
        {
          id: 1,
          name: "Sarah Thompson",
          age: 42,
          condition: "Hypertension",
          lastVisit: "2025-08-01",
          status: "Stable"
        },
        {
          id: 2,
          name: "David Wilson",
          age: 35,
          condition: "Diabetes Type 2",
          lastVisit: "2025-07-28",
          status: "Improving"
        },
        {
          id: 3,
          name: "Lisa Johnson",
          age: 29,
          condition: "Pregnancy",
          lastVisit: "2025-08-05",
          status: "Monitoring"
        },
        {
          id: 4,
          name: "James Miller",
          age: 58,
          condition: "Arthritis",
          lastVisit: "2025-07-15",
          status: "Stable"
        }
      ],
      // Consultation Metrics
      consultationMetrics: [
        {
          id: 1,
          type: "Outpatient (OP)",
          count: 145,
          paiChatValue: "$28,500",
          growth: "+12%"
        },
        {
          id: 2,
          type: "Inpatient (IP)",
          count: 38,
          paiChatValue: "$15,200",
          growth: "+8%"
        },
        {
          id: 3,
          type: "Emergency Room (ER)",
          count: 22,
          paiChatValue: "$8,800",
          growth: "+15%"
        },
        {
          id: 4,
          type: "Chronic Care Management (CCM)",
          count: 65,
          paiChatValue: "$19,500",
          growth: "+18%"
        }
      ],
      // Treatment Tracking
      treatmentTracking: [
        {
          id: 1,
          category: "Medication",
          count: 245,
          description: "Prescriptions and medication management",
          efficiency: "92%"
        },
        {
          id: 2,
          category: "Diagnostic Procedures",
          count: 189,
          description: "Tests, screenings, and diagnostic imaging",
          efficiency: "88%"
        },
        {
          id: 3,
          category: "Therapy",
          count: 156,
          description: "Physical therapy, rehabilitation, counseling",
          efficiency: "85%"
        },
        {
          id: 4,
          category: "Surgical",
          count: 42,
          description: "Surgical procedures and operations",
          efficiency: "95%"
        },
        {
          id: 5,
          category: "Non-Surgical",
          count: 298,
          description: "Non-invasive treatments and procedures",
          efficiency: "90%"
        }
      ],
      // Target Performance
      targetPerformance: [
        {
          id: 1,
          metric: "Patient Consultations",
          target: 300,
          actual: 270,
          percentage: 90,
          status: "Good"
        },
        {
          id: 2,
          metric: "Treatment Success Rate",
          target: 95,
          actual: 92,
          percentage: 97,
          status: "Excellent"
        },
        {
          id: 3,
          metric: "Patient Satisfaction",
          target: 90,
          actual: 94,
          percentage: 104,
          status: "Excellent"
        },
        {
          id: 4,
          metric: "Revenue Target",
          target: 75000,
          actual: 72000,
          percentage: 96,
          status: "Good"
        }
      ],
      // CCM Patient Assignments
      ccmPatients: [
        {
          id: 1,
          name: "Robert Johnson",
          age: 68,
          condition: "Diabetes Type 2 + Hypertension",
          program: "Chronic Care Management",
          assignedDate: "2025-01-15",
          status: "Active",
          lastContact: "2025-08-10"
        },
        {
          id: 2,
          name: "Margaret Davis",
          age: 72,
          condition: "COPD + Heart Failure",
          program: "Chronic Care Management",
          assignedDate: "2025-02-20",
          status: "Active",
          lastContact: "2025-08-08"
        },
        {
          id: 3,
          name: "William Brown",
          age: 65,
          condition: "Chronic Kidney Disease",
          program: "Chronic Care Management",
          assignedDate: "2025-03-10",
          status: "Active",
          lastContact: "2025-08-12"
        },
        {
          id: 4,
          name: "Patricia Wilson",
          age: 70,
          condition: "Arthritis + Osteoporosis",
          program: "Chronic Care Management",
          assignedDate: "2025-01-25",
          status: "Active",
          lastContact: "2025-08-09"
        }
      ],
      todaysAppointments: [
        { id: 101, patientName: "Ava Taylor", time: "09:00 AM", reason: "Fever", status: "Waiting" },
        { id: 102, patientName: "Noah Anderson", time: "09:45 AM", reason: "Cough", status: "Waiting" },
        { id: 103, patientName: "Emma Martinez", time: "10:30 AM", reason: "Headache", status: "Waiting" },
        { id: 104, patientName: "Liam Thomas", time: "11:15 AM", reason: "Follow-up", status: "Waiting" }
      ],
      showConsultModal: false,
      selectedAppointment: null,
      prescriptions: {},

      // Referrals mock data and UI state
      referralPatients: [
        { id: 1, name: "Swaraj Bhuyan", mrn: 8364, dob: "1990-03-12", gender: "Male" },
        { id: 2, name: "John Doe", mrn: 1234, dob: "1985-07-21", gender: "Male" },
        { id: 3, name: "Jane Smith", mrn: 5678, dob: "1992-11-05", gender: "Female" }
      ],
      referralDepartments: [
        { id: 1, name: "Cardiology" },
        { id: 2, name: "Neurology" },
        { id: 3, name: "Orthopedics" }
      ],
      referralDoctors: [
        { id: 11, name: "Dr. Arvind Rao", departmentId: 1 },
        { id: 12, name: "Dr. Nisha Patel", departmentId: 2 },
        { id: 13, name: "Dr. Vikram Singh", departmentId: 3 }
      ],
      referralHospitals: [
        { id: 101, name: "City Hospital" },
        { id: 102, name: "General Hospital" },
        { id: 103, name: "Sunrise Medical Center" }
      ],
      referrals: [],
      showReferralForm: false
    };
  },
  computed: {
    selectedPrescription() {
      return this.selectedAppointment ? (this.prescriptions[this.selectedAppointment.id] || null) : null;
    }
  },
  methods: {
    /**
     * Get the variant class for status
     */
    getStatusVariant(status) {
      switch (status) {
        case "Confirmed":
          return "success";
        case "Pending":
          return "warning";
        case "Cancelled":
          return "danger";
        default:
          return "primary";
      }
    },
    /**
     * Get the variant class for patient status
     */
    getPatientStatusVariant(status) {
      switch (status) {
        case "Stable":
          return "success";
        case "Improving":
          return "info";
        case "Monitoring":
          return "warning";
        case "Critical":
          return "danger";
        default:
          return "primary";
      }
    },
    /**
     * Get the variant class for target performance status
     */
    getPerformanceStatusVariant(status) {
      switch (status) {
        case "Excellent":
          return "success";
        case "Good":
          return "info";
        case "Needs Improvement":
          return "warning";
        case "Poor":
          return "danger";
        default:
          return "primary";
      }
    },
    /**
     * Get efficiency color variant
     */
    getEfficiencyVariant(efficiency) {
      const percent = parseInt(efficiency);
      if (percent >= 90) return "success";
      if (percent >= 75) return "info";
      if (percent >= 60) return "warning";
      return "danger";
    },
    /**
     * Format currency
     */
    formatCurrency(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(value);
    },
    getApptStatusVariant(status) {
      switch (status) {
        case 'Waiting': return 'warning';
        case 'In-progress': return 'info';
        case 'Consult': return 'success';
        default: return 'secondary';
      }
    },
    hasPrescription(appt) {
      return !!this.prescriptions[appt.id];
    },
    openConsult(appt) {
      this.selectedAppointment = appt;
      this.updateAppointmentStatus(appt.id, 'In-progress');
      this.showConsultModal = true;
    },
    viewPrescription(appt) {
      this.selectedAppointment = appt;
      this.showConsultModal = true;
    },
    downloadPrescription(appt) {
      const presc = this.prescriptions[appt.id];
      if (!presc) return;
      const json = JSON.stringify(presc, null, 2);
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const name = (appt.patientName ? appt.patientName.replace(/\s+/g, '_') : 'prescription') + '_prescription.json';
      a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    onConsultSaved(presc) {
      if (this.selectedAppointment) {
        this.$set(this.prescriptions, this.selectedAppointment.id, presc);
        this.updateAppointmentStatus(this.selectedAppointment.id, 'Consult');
      }
    },
    onConsultClosed() {
      if (this.selectedAppointment) {
        const has = !!this.prescriptions[this.selectedAppointment.id];
        if (!has) this.updateAppointmentStatus(this.selectedAppointment.id, 'Waiting');
      }
    },
    // Referral helpers and handlers
    getDepartmentName(id) {
      const d = this.referralDepartments.find(x => x.id === id);
      return d ? d.name : '-';
    },
    getDoctorName(id) {
      const d = this.referralDoctors.find(x => x.id === id);
      return d ? d.name : '-';
    },
    getUrgencyVariant(u) {
      switch (u) {
        case 'Low': return 'secondary';
        case 'Medium': return 'info';
        case 'High': return 'warning';
        case 'Critical': return 'danger';
        default: return 'secondary';
      }
    },
    formatDateTime(dt) {
      const d = new Date(dt);
      if (isNaN(d.getTime())) return dt;
      return d.toLocaleString();
    },
    onReferralSubmit(ref) {
      const id = Date.now();
      this.referrals.unshift({ ...ref, id });
      this.showReferralForm = false;
    },
    onReferralCancel() {
      this.showReferralForm = false;
    },
    updateAppointmentStatus(id, status) {
      const appt = this.todaysAppointments.find(a => a.id === id);
      if (appt) appt.status = status;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-xl-12">
        <div class="row">
          <div v-for="(stat, index) in doctorStats" :key="index" class="col-md-3">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <p class="text-muted fw-medium">{{ stat.title }}</p>
                    <h4 class="mb-0">{{ stat.value }}</h4>
                  </div>
                  <div class="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                    <span class="avatar-title">
                      <i :class="`${stat.icon} font-size-24`"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Today's Appointments -->
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Today's Appointments</h4>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Patient</th>
                    <th>Time</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="appt in todaysAppointments" :key="appt.id">
                    <td>{{ appt.patientName }}</td>
                    <td>{{ appt.time }}</td>
                    <td>{{ appt.reason }}</td>
                    <td>
                      <span :class="`badge bg-${getApptStatusVariant(appt.status)} font-size-12`">{{ appt.status }}</span>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-primary me-1" @click="openConsult(appt)">Consult</button>
                      <button class="btn btn-sm btn-info me-1" :disabled="!hasPrescription(appt)" @click="viewPrescription(appt)">View</button>
                      <button class="btn btn-sm btn-success" :disabled="!hasPrescription(appt)" @click="downloadPrescription(appt)">Download</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Referrals Section -->
    <div class="row">
      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Referrals</h4>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Patient</th>
                    <th>Type</th>
                    <th>Department</th>
                    <th>Doctor</th>
                    <th>Urgency</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!referrals.length">
                    <td colspan="6" class="text-center text-muted">No referrals yet</td>
                  </tr>
                  <tr v-for="ref in referrals" :key="ref.id">
                    <td>{{ ref.patient ? ref.patient.name : '' }} <small class="text-muted">(Mrn: {{ ref.patient ? ref.patient.mrn : '' }})</small></td>
                    <td>
                      <span :class="`badge bg-${ref.type === 'internal' ? 'primary' : 'secondary'} font-size-12`">{{ ref.type }}</span>
                    </td>
                    <td>{{ getDepartmentName(ref.departmentId) }}</td>
                    <td>{{ getDoctorName(ref.doctorId) }}</td>
                    <td>
                      <span :class="`badge bg-${getUrgencyVariant(ref.urgency)} font-size-12`">{{ ref.urgency }}</span>
                    </td>
                    <td>{{ formatDateTime(ref.createdAt) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="card-title mb-0">New Referral</h4>
              <button class="btn btn-sm btn-primary" @click="showReferralForm = !showReferralForm">{{ showReferralForm ? 'Hide' : 'Create Referral' }}</button>
            </div>
            <div class="mt-3">
              <CreateReferralForm
                :show="showReferralForm"
                :patients="referralPatients"
                :departments="referralDepartments"
                :doctors="referralDoctors"
                :hospitals="referralHospitals"
                @update:show="val => showReferralForm = val"
                @submit="onReferralSubmit"
                @cancel="onReferralCancel"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Consultation Metrics -->
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Consultation Metrics (OP/IP/ER/CCM)</h4>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Consultation Type</th>
                    <th>Total Count</th>
                    <th>Pai Chat Value</th>
                    <th>Growth</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="consultation in consultationMetrics" :key="consultation.id">
                    <td>{{ consultation.type }}</td>
                    <td>
                      <span class="fw-bold text-primary">{{ consultation.count }}</span>
                    </td>
                    <td>{{ consultation.paiChatValue }}</td>
                    <td>
                      <span class="badge bg-success font-size-12">
                        {{ consultation.growth }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Treatment Tracking -->
    <div class="row">
      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Treatment Tracking (Medication, Diagnostic, Therapy, Surgical & Non-Surgical)</h4>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Treatment Category</th>
                    <th>Count</th>
                    <th>Description</th>
                    <th>Efficiency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="treatment in treatmentTracking" :key="treatment.id">
                    <td>{{ treatment.category }}</td>
                    <td>
                      <span class="fw-bold text-primary">{{ treatment.count }}</span>
                    </td>
                    <td>{{ treatment.description }}</td>
                    <td>
                      <div class="progress" style="height: 5px;">
                        <div 
                          class="progress-bar" 
                          :class="`bg-${getEfficiencyVariant(treatment.efficiency)}`"
                          role="progressbar" 
                          :style="`width: ${treatment.efficiency}`" 
                          :aria-valuenow="parseInt(treatment.efficiency)" 
                          aria-valuemin="0" 
                          aria-valuemax="100">
                        </div>
                      </div>
                      <span class="mt-1 d-block">{{ treatment.efficiency }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Today's Summary</h4>
            <div class="text-center">
              <div class="mb-4">
                <h3 class="text-primary">18</h3>
                <p class="text-muted">Appointments Today</p>
              </div>
              <div class="mb-4">
                <h4 class="text-success">$2,850</h4>
                <p class="text-muted">Today's Revenue</p>
              </div>
              <div class="mb-4">
                <h5 class="text-info">65</h5>
                <p class="text-muted">CCM Patients Assigned</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Target Performance -->
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Target vs Actual Performance</h4>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Performance Metric</th>
                    <th>Target</th>
                    <th>Actual</th>
                    <th>Achievement %</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="target in targetPerformance" :key="target.id">
                    <td>{{ target.metric }}</td>
                    <td>{{ target.metric === 'Revenue Target' ? formatCurrency(target.target) : target.target }}</td>
                    <td>{{ target.metric === 'Revenue Target' ? formatCurrency(target.actual) : target.actual }}</td>
                    <td>
                      <div class="progress" style="height: 5px;">
                        <div 
                          class="progress-bar" 
                          :class="`bg-${getPerformanceStatusVariant(target.status)}`"
                          role="progressbar" 
                          :style="`width: ${Math.min(target.percentage, 100)}%`" 
                          :aria-valuenow="target.percentage" 
                          aria-valuemin="0" 
                          aria-valuemax="100">
                        </div>
                      </div>
                      <span class="mt-1 d-block">{{ target.percentage }}%</span>
                    </td>
                    <td>
                      <span :class="`badge bg-${getPerformanceStatusVariant(target.status)} font-size-12`">
                        {{ target.status }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CCM Patient Assignments -->
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">CCM Patient Programs Assigned</h4>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Patient Name</th>
                    <th>Age</th>
                    <th>Condition</th>
                    <th>Program</th>
                    <th>Assigned Date</th>
                    <th>Last Contact</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="patient in ccmPatients" :key="patient.id">
                    <td>{{ patient.name }}</td>
                    <td>{{ patient.age }}</td>
                    <td>{{ patient.condition }}</td>
                    <td>{{ patient.program }}</td>
                    <td>{{ patient.assignedDate }}</td>
                    <td>{{ patient.lastContact }}</td>
                    <td>
                      <span class="badge bg-success font-size-12">
                        {{ patient.status }}
                      </span>
                    </td>
                    <td>
                      <button class="btn btn-primary btn-sm me-1">View</button>
                      <button class="btn btn-info btn-sm">Contact</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DoctorConsultModal
      v-model="showConsultModal"
      :appointment="selectedAppointment"
      :existing="selectedPrescription"
      @saved="onConsultSaved"
      @closed="onConsultClosed"
    />
  </Layout>
</template>

<style scoped>
.mini-stat-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>